/* eslint-disable max-len */
import { Colors } from '../../styles'

const PortSvg = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
      <g transform='translate(.5 .5)'>
        <circle
          cx={11.625}
          cy={11.625}
          r={11.625}
          fill='#ea1e23'
          stroke='#fff'
          strokeMiterlimit={10}
        />
        <path
          d='M15.14 16.078a1.841 1.841 0 01-1.828 1.547H9.937a1.848 1.848 0 01-1.852-1.547 4.573 4.573 0 01-3.679 1.547.271.271 0 01-.281-.281v-.562a.285.285 0 01.281-.281 3.434 3.434 0 003.352-1.97L6 13.055a1.132 1.132 0 01.375-1.922l1.313-.446v-3a.555.555 0 01.562-.562h1.125v-.938a.555.555 0 01.562-.562h3.375a.57.57 0 01.563.562v.938H15a.57.57 0 01.562.563v3l1.289.446a1.132 1.132 0 01.374 1.921l-1.756 1.476a3.433 3.433 0 003.375 1.969.3.3 0 01.281.281v.562a.285.285 0 01-.281.281 4.521 4.521 0 01-3.704-1.546z'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

const FloatingCrane = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
      <defs>
        <style>{'.prefix__b{fill:#fff}'}</style>
      </defs>
      <g transform='translate(.5 .5)'>
        <circle
          cx={11.625}
          cy={11.625}
          r={11.625}
          fill='#407c00'
          stroke='#fff'
          strokeMiterlimit={10}
        />
        <path
          className='prefix__b'
          d='M7.406 18.41a.352.352 0 10.351.352.352.352 0 00-.351-.352zM12.328 18.41H8.813a.352.352 0 100 .7h3.515a.352.352 0 000-.7z'
        />
        <path
          className='prefix__b'
          d='M6 20.625a.352.352 0 01-.352-.352v-2.214a1.056 1.056 0 011.055-1.055h1.055V8.953h-.7v1.758a.351.351 0 01-.351.352H3.679a.351.351 0 01-.354-.352V8.953h-.348a.351.351 0 01-.352-.352V7.195a.355.355 0 01.169-.3l6.177-3.77a1.06 1.06 0 01.9-.5 1.05 1.05 0 01.684.255l9.844 3.987a.354.354 0 01.226.327v1.407a.352.352 0 01-.352.352h-1.054v1.431a.353.353 0 01-.1.248l-.6.6v2.393a.352.352 0 01-.352.352.352.352 0 10.318.5.352.352 0 11.637.3 1.055 1.055 0 11-1.306-1.444v-2.1l-.6-.6a.351.351 0 01-.1-.248V8.953h-5.14v8.051h1.055a1.056 1.056 0 011.054 1.055v2.215a.352.352 0 01-.352.352z'
        />
      </g>
    </svg>
  )
}

const Satellite = (props) => {
  return (
    <svg width='20' height='30' viewBox='0 0 25 25' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M19.852 10.624l-.5-.5a.361.361 0 10-.511.511l.236.236a3.876 3.876 0 01-5.458-5.458l3.994 3.994a.361.361 0 00.511-.511l-.279-.279 1-2.5a.364.364 0 00-.469-.469l-2.5 1-2.011-2.011a.365.365 0 00-.511 0 4.6 4.6 0 006.5 6.5.361.361 0 00-.002-.513zm-1.993-4l-.573 1.433-.211-.211-.649-.649zM22.27 2.214A4.568 4.568 0 0019.019.867a.361.361 0 100 .722 3.876 3.876 0 013.876 3.876.361.361 0 00.722 0 4.568 4.568 0 00-1.347-3.251z'
      />
      <path
        className='prefix__a'
        d='M21.181 3.304a3.037 3.037 0 00-2.162-.9.361.361 0 100 .722 2.335 2.335 0 012.335 2.335.361.361 0 10.722 0 3.037 3.037 0 00-.895-2.157zM20.091 4.393a1.507 1.507 0 00-1.069-.444.361.361 0 000 .722.795.795 0 01.795.794.361.361 0 10.722 0 1.507 1.507 0 00-.448-1.072zM24.38 20.054l-6.537-6.537a.365.365 0 00-.511 0l-1.65 1.652-1.838-1.838.556-.562a.365.365 0 000-.511l-2.174-2.179a.361.361 0 00-.511 0l-.562.562-1.838-1.838 1.651-1.651a.361.361 0 000-.511L4.43.104a.365.365 0 00-.511 0L.106 3.917a.361.361 0 000 .511l6.537 6.541a.365.365 0 00.511 0L8.8 9.313l1.838 1.838-.562.562a.365.365 0 000 .511l.289.289-.562.562a.365.365 0 000 .511l1.097 1.089a.365.365 0 00.511 0l.562-.562.289.289a.365.365 0 00.511 0l.562-.562 1.838 1.838-1.653 1.653a.361.361 0 000 .511l6.537 6.537a.365.365 0 00.511 0l3.812-3.81a.361.361 0 000-.515zM8.021 4.717l-1.4 1.4-1.664-1.672 1.4-1.4zM4.174.869l1.669 1.669-1.4 1.4-1.664-1.669zM2.541 5.841L.872 4.169l1.4-1.4 1.664 1.676-1.379 1.379zM4.72 8.02L3.05 6.35l.018-.016 1.379-1.379 1.668 1.669-1.379 1.378zm2.18 2.178L5.229 8.529l.018-.016 1.379-1.379 1.668 1.669zm.238-3.575l1.4-1.4L10.2 6.896l-1.4 1.4zm4.017 7.286l-.579-.579.306-.306.579.579zm1.362-.272l-1.67-1.668 1.124-1.123 1.668 1.668zm8.92 4.494l-1.4 1.4-1.666-1.672 1.4-1.4zm-3.847-3.847l1.668 1.668-1.4 1.4-1.668-1.668zm-1.633 4.971l-1.669-1.669 1.4-1.4 1.662 1.673-1.379 1.379zm2.179 2.179l-1.67-1.67.018-.016 1.377-1.379 1.668 1.668-1.379 1.379zm2.178 2.178l-1.669-1.669.018-.016 1.379-1.379 1.668 1.668zm1.906-1.907l-1.67-1.668 1.4-1.4 1.668 1.668z'
      />
    </svg>
  )
}
const StreetView = (props) => {
  return (
    <svg width='25' height='25' viewBox='0 0 24 24' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M21.8 4.2c-7.577-1.506-7.086-1.427-7.258-1.4-.055.009-.727.144-2.295.458a4.841 4.841 0 00-9.153.005l-2.317-.46A.654.654 0 000 3.446v15.352a.654.654 0 00.527.642c7.513 1.493 7.021 1.4 7.071 1.4.158.019-.33.1 7.058-1.377l6.894 1.37a.654.654 0 00.782-.642V4.841a.654.654 0 00-.527-.642zM7.676 1.308a3.537 3.537 0 013.533 3.533c0 1.644-2.63 5.816-3.533 7.2-.9-1.379-3.533-5.552-3.533-7.2a3.537 3.537 0 013.533-3.533zM1.308 4.243l1.536.305c-.006.1-.009.195-.009.293 0 1.091.714 2.852 2.182 5.382a55.646 55.646 0 002.005 3.194v5.979l-5.714-1.135zm7.022 9.174c.3-.447 1.148-1.716 2.005-3.194 1.468-2.531 2.182-4.291 2.182-5.382 0-.1 0-.2-.01-.3l1.492-.3v14.021L8.33 19.396zm12.692 5.979l-5.714-1.136V4.243l5.714 1.136z'
      />
      <path
        className='prefix__a'
        d='M7.676 6.891a2.05 2.05 0 10-2.05-2.05 2.052 2.052 0 002.05 2.05zm0-2.791a.741.741 0 11-.741.741.742.742 0 01.741-.742z'
      />
    </svg>
  )
}

const PointHere = (props) => {
  return (
    <svg width='25' height='25' viewBox='0 0 24 24' {...props}>
      <g fill='#0076ff' stroke='#fff'>
        <circle cx={6} cy={6} r={6} stroke='none' />
        <circle cx={6} cy={6} r={5.5} fill='none' />
      </g>
    </svg>
  )
}

const HomeIcon = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 22.701 22.701' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M7.715 10.641H2.926A2.93 2.93 0 010 7.715V2.926A2.93 2.93 0 012.926 0h4.789a2.93 2.93 0 012.926 2.926v4.789a2.93 2.93 0 01-2.926 2.926zM2.926 1.419a1.509 1.509 0 00-1.507 1.507v4.789a1.509 1.509 0 001.507 1.507h4.789a1.509 1.509 0 001.507-1.507V2.926a1.509 1.509 0 00-1.507-1.507zM19.775 10.641h-4.788a2.93 2.93 0 01-2.927-2.926V2.926A2.93 2.93 0 0114.986 0h4.788A2.93 2.93 0 0122.7 2.926v4.789a2.93 2.93 0 01-2.925 2.926zm-4.788-9.222a1.509 1.509 0 00-1.507 1.507v4.789a1.509 1.509 0 001.507 1.507h4.788a1.509 1.509 0 001.507-1.507V2.926a1.509 1.509 0 00-1.507-1.507zM17.38 22.701a5.32 5.32 0 115.32-5.32 5.327 5.327 0 01-5.32 5.32zm0-9.222a3.9 3.9 0 103.9 3.9 3.906 3.906 0 00-3.9-3.9zM7.715 22.701H2.926A2.93 2.93 0 010 19.775v-4.788a2.93 2.93 0 012.926-2.927h4.789a2.93 2.93 0 012.926 2.926v4.788a2.93 2.93 0 01-2.926 2.927zm-4.788-9.222a1.509 1.509 0 00-1.507 1.507v4.788a1.509 1.509 0 001.507 1.507h4.788a1.509 1.509 0 001.507-1.507v-4.788a1.509 1.509 0 00-1.507-1.507z'
      />
    </svg>
  )
}

const LintasIcon = (props) => {
  return (
    <svg
      id='prefix__Layer_1'
      x={0}
      y={0}
      viewBox='0 0 226 71'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>
        {'.prefix__st0{enable-background:new}.prefix__st1{fill:#f2f2f2}'}
      </style>
      <g className='prefix__st0'>
        <path
          className='prefix__st1'
          d='M209.8 41.3v8.4h-4.4V25.8h7.8c1.6 0 3 .2 4.1.6s2.1.9 2.9 1.6c.8.7 1.3 1.5 1.7 2.4s.5 2 .5 3.1c0 1.2-.2 2.2-.6 3.2s-1 1.8-1.7 2.5c-.8.7-1.7 1.2-2.9 1.6-1.2.4-2.5.6-4.1.6h-3.3zm0-3.5h3.3c.8 0 1.5-.1 2.1-.3.6-.2 1.1-.5 1.5-.9.4-.4.7-.8.9-1.4.2-.5.3-1.2.3-1.8 0-.6-.1-1.2-.3-1.7-.2-.5-.5-1-.9-1.3-.4-.4-.9-.6-1.5-.8-.6-.2-1.3-.3-2.1-.3h-3.3v8.5zM248.8 37.7c0 1.7-.3 3.4-.9 4.9-.6 1.5-1.4 2.8-2.5 3.9s-2.3 1.9-3.8 2.5c-1.5.6-3.1.9-4.9.9-1.8 0-3.5-.3-4.9-.9-1.5-.6-2.8-1.5-3.8-2.5-1.1-1.1-1.9-2.4-2.5-3.9-.6-1.5-.9-3.1-.9-4.9s.3-3.4.9-4.9c.6-1.5 1.4-2.8 2.5-3.9s2.3-1.9 3.8-2.5c1.5-.6 3.1-.9 4.9-.9 1.8 0 3.4.3 4.9.9 1.5.6 2.8 1.5 3.8 2.5 1.1 1.1 1.9 2.4 2.5 3.9.6 1.6.9 3.2.9 4.9zm-4.6 0c0-1.3-.2-2.5-.5-3.5s-.8-1.9-1.5-2.6c-.6-.7-1.4-1.3-2.4-1.7-.9-.4-2-.6-3.1-.6s-2.2.2-3.2.6c-.9.4-1.7.9-2.4 1.7-.7.7-1.2 1.6-1.5 2.6-.4 1-.5 2.2-.5 3.5 0 1.3.2 2.5.5 3.5.4 1 .9 1.9 1.5 2.6s1.4 1.3 2.4 1.7c.9.4 2 .6 3.2.6s2.2-.2 3.1-.6 1.7-.9 2.4-1.7 1.1-1.6 1.5-2.6c.3-1 .5-2.2.5-3.5zM256.9 40.3v9.3h-4.4V25.8h7.3c1.6 0 3 .2 4.2.5 1.2.3 2.1.8 2.9 1.4.7.6 1.3 1.3 1.6 2.2.3.8.5 1.8.5 2.8 0 .8-.1 1.6-.4 2.3s-.6 1.4-1 1.9c-.4.6-1 1.1-1.7 1.5-.7.4-1.4.8-2.2 1.1.6.3 1 .8 1.5 1.4l6 8.8h-4c-.4 0-.7-.1-1-.2-.3-.2-.5-.4-.7-.7l-5-7.6c-.2-.3-.4-.5-.6-.6-.2-.1-.6-.2-1-.2h-2zm0-3.1h2.8c.8 0 1.6-.1 2.2-.3.6-.2 1.1-.5 1.5-.9s.7-.8.9-1.3c.2-.5.3-1.1.3-1.7 0-1.2-.4-2.1-1.2-2.8-.8-.6-2-1-3.7-1h-2.8v8zM289.8 25.8v3.6h-7.2v20.2h-4.4V29.4H271v-3.6h18.8z'
          transform='translate(-64.849 -16.662)'
        />
      </g>
      <g className='prefix__st0'>
        <path
          className='prefix__st1'
          d='M212.2 56.2c-.1.1-.1.2-.2.2s-.2.1-.3.1c-.1 0-.2 0-.4-.1-.1-.1-.3-.2-.5-.3l-.6-.3c-.2-.1-.5-.1-.9-.1-.3 0-.6 0-.8.1l-.6.3c-.2.1-.3.3-.3.5s-.1.4-.1.6c0 .3.1.5.2.7.2.2.4.3.6.5.3.1.5.2.9.3s.6.2 1 .3c.3.1.7.2 1 .4.3.2.6.3.9.6.3.2.5.5.6.9s.2.7.2 1.2-.1 1-.3 1.5-.4.9-.8 1.2c-.3.3-.8.6-1.3.8s-1.1.3-1.7.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.2-1-.3-.3-.1-.6-.3-.9-.5-.3-.2-.5-.4-.8-.6l.6-1 .2-.2c.1-.1.2-.1.3-.1.1 0 .3.1.4.2.2.1.3.2.5.4.2.1.5.3.7.4s.6.2 1 .2c.6 0 1.1-.1 1.4-.4.3-.3.5-.7.5-1.3 0-.3-.1-.6-.2-.7-.2-.2-.4-.4-.6-.5-.3-.1-.5-.2-.9-.3-.3-.1-.6-.2-1-.3s-.7-.2-1-.4c-.3-.1-.6-.3-.9-.6-.3-.2-.5-.5-.6-.9-.2-.4-.2-.8-.2-1.3 0-.4.1-.8.3-1.2.2-.4.4-.8.7-1.1s.7-.6 1.2-.7c.5-.2 1-.3 1.6-.3.7 0 1.3.1 1.9.3s1.1.5 1.5.9l-.2.7zM223.5 54.1v1.7h-5.1V59h4v1.7h-4V64h5.1v1.7h-7.3V54.1h7.3zM229.2 61.1v4.5H227V54.1h3.5c.8 0 1.5.1 2 .2.6.2 1 .4 1.4.7.4.3.6.6.8 1.1s.3.9.3 1.3-.1.8-.2 1.1c-.1.3-.3.7-.5.9-.2.3-.5.5-.8.7-.3.2-.7.4-1.1.5.3.2.5.4.7.7l2.9 4.3h-1.9c-.2 0-.3 0-.5-.1l-.3-.3-2.4-3.7-.3-.3c-.1-.1-.3-.1-.5-.1h-.9zm0-1.5h1.3c.4 0 .8 0 1.1-.2.3-.1.5-.2.7-.4.2-.2.3-.4.4-.6.1-.2.1-.5.1-.8 0-.6-.2-1-.6-1.4-.4-.3-1-.5-1.8-.5H229v3.9zM237.9 54.1h1.7c.2 0 .3 0 .5.1s.2.2.3.4l2.7 7.1c.1.2.2.5.3.8.1.3.2.6.2.9.1-.6.3-1.2.5-1.6l2.7-7.1c0-.1.1-.2.3-.3.1-.1.3-.2.5-.2h1.7l-4.7 11.6h-1.9l-4.8-11.7zM254.4 65.7h-2.2V54.1h2.2v11.6zM266.6 62.9c.1 0 .2 0 .3.1l.8.9c-.5.6-1 1-1.7 1.3-.7.3-1.5.5-2.5.5-.9 0-1.6-.1-2.3-.4-.7-.3-1.3-.7-1.8-1.2s-.9-1.1-1.1-1.9c-.3-.7-.4-1.5-.4-2.4 0-.9.1-1.7.4-2.4.3-.7.7-1.3 1.2-1.9.5-.5 1.1-.9 1.9-1.2.7-.3 1.5-.4 2.4-.4.9 0 1.6.1 2.3.4.6.3 1.2.6 1.7 1.1l-.7 1c0 .1-.1.1-.2.2-.1 0-.2.1-.3.1-.1 0-.2 0-.4-.1-.1-.1-.3-.2-.5-.3-.2-.1-.4-.2-.7-.3-.3-.1-.7-.1-1.1-.1-.5 0-1 .1-1.5.3s-.8.5-1.2.8c-.3.4-.6.8-.8 1.3-.2.5-.3 1.1-.3 1.7 0 .7.1 1.2.3 1.7.2.5.4.9.7 1.3.3.3.7.6 1.1.8.4.2.9.3 1.4.3h.8c.2 0 .5-.1.7-.2l.6-.3c.2-.1.4-.2.5-.4.1 0 .1-.1.2-.1s.1-.2.2-.2zM278.2 54.1v1.7h-5.1V59h4v1.7h-4V64h5.1v1.7H271V54.1h7.2zM287.9 56.2c-.1.1-.1.2-.2.2s-.2.1-.3.1c-.1 0-.2 0-.4-.1-.1-.1-.3-.2-.5-.3l-.6-.3c-.2-.1-.5-.1-.9-.1-.3 0-.6 0-.8.1l-.6.3c-.2.1-.3.3-.3.5s-.1.4-.1.6c0 .3.1.5.2.7.2.2.4.3.6.5.3.1.5.2.9.3s.6.2 1 .3c.3.1.7.2 1 .4.3.2.6.3.9.6.3.2.5.5.6.9s.2.7.2 1.2-.1 1-.3 1.5-.4.9-.8 1.2c-.3.3-.8.6-1.3.8s-1.1.3-1.7.3c-.4 0-.7 0-1.1-.1-.4-.1-.7-.2-1-.3-.3-.1-.6-.3-.9-.5-.3-.2-.5-.4-.8-.6l.6-1 .2-.2c.1-.1.2-.1.3-.1.1 0 .3.1.4.2.2.1.3.2.5.4.2.1.5.3.7.4s.6.2 1 .2c.6 0 1.1-.1 1.4-.4.3-.3.5-.7.5-1.3 0-.3-.1-.6-.2-.7-.2-.2-.4-.4-.6-.5-.3-.1-.5-.2-.9-.3-.3-.1-.6-.2-1-.3s-.7-.2-1-.4c-.3-.1-.6-.3-.9-.6-.3-.2-.5-.5-.6-.9-.2-.4-.2-.8-.2-1.3 0-.4.1-.8.3-1.2.2-.4.4-.8.7-1.1s.7-.6 1.2-.7c.5-.2 1-.3 1.6-.3.7 0 1.3.1 1.9.3s1.1.5 1.5.9l-.2.7z'
          transform='translate(-64.849 -16.662)'
        />
      </g>
      <path
        fill='none'
        stroke='#fff'
        d='M193.3 18.2v55'
        transform='translate(-64.849 -16.662)'
      />
      <g className='prefix__st0'>
        <path
          className='prefix__st1'
          d='M67.8 56.3V27.8H74v26.4c0 1 .2 1.6.5 2 .3.4.9.5 1.7.5.8 0 1.6-.1 2.3-.3v5.3c-1.5.3-2.8.5-3.9.5-4.5 0-6.8-2-6.8-5.9zM82.4 29.4h6.2v6h-6.2v-6zm0 9.7h6.2v22.5h-6.2V39.1zM113.7 40.9c1.5 1.5 2.2 3.9 2.2 7.2v13.5h-6.2V48.1c0-1.3-.3-2.3-.9-3-.6-.7-1.6-1-3-1-1.7 0-3.4.7-5.1 2.1v15.4h-6.2V39.1h6.2v2c2-1.6 4.1-2.4 6.4-2.4 3 0 5.2.7 6.6 2.2zM129.2 45.3v8.9c0 .9.2 1.6.5 2 .3.4.9.6 1.7.6.9 0 1.7-.1 2.4-.3v5.3c-1.5.3-2.9.5-4 .5-2.3 0-4-.5-5.1-1.5s-1.6-2.5-1.6-4.4v-11h-3v-5.5h3v-7.6h6.2v7.6h5.1v5.5h-5.2zM153.3 40.3c1.4.8 2.4 1.8 2.9 3.1s.7 3 .7 5v13.2h-6.2v-1.9c-1 .9-1.9 1.5-2.8 1.9-.9.4-1.9.6-3.1.6-2.5 0-4.4-.7-5.8-2s-2.2-3.2-2.2-5.6c0-2.4.7-4.3 2.2-5.6s3.5-2 6.1-2c2.1 0 3.9.4 5.5 1.2 0-.9-.1-1.6-.4-2.1-.2-.5-.6-.9-1.3-1.2-.6-.3-1.6-.4-2.8-.4h-4.2v-5.4h4.8c3.1 0 5.2.4 6.6 1.2zm-2.5 15v-2.8c-1.4-.7-2.8-1-4.1-1-1.1 0-1.9.2-2.6.7-.6.5-1 1.2-1 2.3 0 1.9 1 2.8 3 2.8 1.5 0 3.1-.6 4.7-2zM165.8 61.9c-1.4-.3-2.9-.8-4.4-1.5v-5.5c1.5.8 3 1.4 4.5 1.8 1.5.4 3.1.5 4.8.5 2 0 3-.7 3-2 0-.5-.2-.9-.5-1.2-.3-.3-.8-.5-1.5-.7l-3.6-.8c-2.2-.5-3.8-1.2-4.8-2.3-1-1.1-1.6-2.5-1.6-4.4 0-4.9 3-7.3 9.1-7.3 2.5 0 5.2.5 8 1.4v5.3c-1-.5-2.2-.9-3.6-1.2-1.4-.3-2.7-.4-4.1-.4-1.2 0-2 .1-2.5.4-.5.3-.7.7-.7 1.3 0 .5.1.8.4 1.1s.8.4 1.4.6l3.6.8c2.3.5 3.9 1.2 5 2.3s1.6 2.7 1.6 4.8c0 2.5-.8 4.3-2.5 5.6s-3.9 1.9-6.7 1.9c-1.9-.1-3.5-.2-4.9-.5z'
          transform='translate(-64.849 -16.662)'
        />
      </g>
    </svg>
  )
}

const FullScreenEnter = (props) => {
  return (
    <svg width='19' height='30' viewBox='19 17 24 21' {...props}>
      <defs>
        <style>{'.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__b'
        d='M40.701 16.399h-4.884a.514.514 0 00-.514.514v1.372a.514.514 0 00.514.514h1.3l-3.916 3.918a.514.514 0 000 .727l.97.97a.514.514 0 00.727 0l3.913-3.922v1.3a.514.514 0 00.514.514h1.372a.514.514 0 00.514-.514v-4.879a.514.514 0 00-.51-.514zM23.562 18.799h1.3a.514.514 0 00.514-.514v-1.372a.514.514 0 00-.514-.514h-4.886a.514.514 0 00-.514.514v4.885a.514.514 0 00.514.514h1.372a.514.514 0 00.514-.514v-1.306l3.918 3.922a.515.515 0 00.728 0l.97-.97a.514.514 0 000-.727zM26.507 29.986a.515.515 0 00-.728 0l-3.917 3.913v-1.3a.514.514 0 00-.514-.514h-1.372a.514.514 0 00-.514.514v4.884a.514.514 0 00.514.514h4.886a.514.514 0 00.514-.514v-1.372a.514.514 0 00-.514-.512h-1.3l3.918-3.917a.514.514 0 000-.727zM40.701 32.088h-1.372a.514.514 0 00-.514.514v1.3l-3.918-3.918a.514.514 0 00-.727 0l-.97.97a.514.514 0 000 .727l3.918 3.917h-1.3a.514.514 0 00-.514.514v1.372a.514.514 0 00.514.514h4.884a.514.514 0 00.514-.514v-4.886a.514.514 0 00-.515-.51z'
      />
    </svg>
  )
}

const FullScreenExit = (props) => {
  return (
    <svg width='19' height='30' viewBox='19 17 24 21' {...props}>
      <defs>
        <style>{'.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__b'
        d='M33.565 24.565h4.884a.514.514 0 00.514-.514v-1.372a.514.514 0 00-.514-.514h-1.3l3.916-3.918a.514.514 0 000-.727l-.97-.97a.514.514 0 00-.727 0l-3.913 3.922v-1.3a.514.514 0 00-.514-.514h-1.372a.514.514 0 00-.514.514v4.879a.514.514 0 00.51.514zM23.528 22.165h-1.3a.514.514 0 00-.514.514v1.372a.514.514 0 00.514.514h4.886a.514.514 0 00.514-.514v-4.885a.514.514 0 00-.514-.514h-1.372a.514.514 0 00-.514.514v1.306L21.31 16.55a.515.515 0 00-.728 0l-.97.97a.514.514 0 000 .727zM20.583 37.85a.515.515 0 00.728 0l3.917-3.913v1.3a.514.514 0 00.514.514h1.372a.514.514 0 00.514-.514v-4.884a.514.514 0 00-.514-.514h-4.886a.514.514 0 00-.514.514v1.372a.514.514 0 00.514.512h1.3l-3.918 3.917a.514.514 0 000 .727zM33.564 35.748h1.372a.514.514 0 00.514-.514v-1.3l3.918 3.918a.514.514 0 00.727 0l.97-.97a.514.514 0 000-.727l-3.918-3.917h1.3a.514.514 0 00.514-.514v-1.372a.514.514 0 00-.514-.514h-4.884a.514.514 0 00-.514.514v4.886a.514.514 0 00.515.51z'
      />
    </svg>
  )
}

const Logout = (props) => {
  return (
    <svg width='25' height='27' viewBox='0 0 25.313 27.001' {...props}>
      <defs>
        <style>{`.prefix__logout_a{fill:${
          props.color === 'blue' ? Colors.aliceBlue : '#fff'
        }`}</style>
      </defs>
      <path
        className='prefix__logout_a'
        d='M19.403 17.415a.791.791 0 01-.418-.7v-.791h-5.537a.791.791 0 01-.791-.791v-3.161a.791.791 0 01.791-.791h5.537v-.791a.791.791 0 011.23-.658l4.746 3.164a.791.791 0 010 1.316l-4.746 3.164a.791.791 0 01-.812.039zm0 0M17.403.789v8.81h-3.955a2.193 2.193 0 00-.791.142v-4.2a2.379 2.379 0 00-1.313-2.12L4.525.001h12.087a.783.783 0 01.791.788zm0 0M13.448 17.509h3.955v5.537a.783.783 0 01-.791.791h-3.955v-6.471a2.193 2.193 0 00.791.143zm0 0'
      />
      <path
        className='prefix__logout_a'
        d='M10.632 4.826L1.139.08A.806.806 0 00.38.111.823.823 0 000 .792v22.254a.769.769 0 00.538.744l9.492 3.164a.779.779 0 00.712-.095.824.824 0 00.332-.648V5.538a.81.81 0 00-.442-.712zM7.91 15.136a.791.791 0 11-1.582 0v-3.164a.791.791 0 011.582 0zm0 0'
      />
    </svg>
  )
}

const ProgressDone = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 22.462 22.462' {...props}>
      <path
        d='M11.231 0a11.231 11.231 0 1011.231 11.231A11.244 11.244 0 0011.231 0zm6.261 7.486l-6.912 7.775a.865.865 0 01-1.186.1l-4.32-3.456a.864.864 0 011.079-1.349L9.834 13.5 16.2 6.337a.865.865 0 011.292 1.149z'
        fill='#95c123'
      />
    </svg>
  )
}

const ProgressError = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 22.46 22.46' {...props}>
      <path
        d='M19.175 3.285a11.235 11.235 0 100 15.889 11.248 11.248 0 000-15.889zM15.66 15.66a.864.864 0 01-1.222 0l-3.208-3.208-3.361 3.361a.864.864 0 01-1.222-1.222l3.361-3.361L6.8 8.021A.864.864 0 118.021 6.8l3.209 3.209 3.056-3.056a.864.864 0 111.222 1.222l-3.056 3.055 3.209 3.209a.864.864 0 01-.001 1.221z'
        fill='red'
      />
    </svg>
  )
}

const ProgressGrey = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 22.46 22.46' {...props}>
      <circle
        cx={11.23}
        cy={11.23}
        r={11.23}
        transform='rotate(90 11.23 11.23)'
        opacity={0.4}
        fill='#d8d8d8'
      />
      <circle
        cx={4.5}
        cy={4.5}
        r={4.5}
        transform='rotate(90 4.43 11.43)'
        fill='#343f54'
        opacity={0.4}
      />
    </svg>
  )
}

const Progress1 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 39.001 39.001' {...props}>
      <defs>
        <style>{'.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        d='M38.764 6.738l-6.5-6.5A.818.818 0 0031.688 0H2.438A2.44 2.44 0 000 2.438v34.125A2.44 2.44 0 002.438 39h34.125A2.44 2.44 0 0039 36.563V7.313a.818.818 0 00-.236-.575zm0 0'
        fill='#95c123'
      />
      <path
        className='prefix__b'
        d='M9.75 0v10.563A2.441 2.441 0 0012.188 13h14.625a2.441 2.441 0 002.438-2.438V0zm0 0M30.063 14.625H8.938a4.067 4.067 0 00-4.063 4.062V39h29.251V18.687a4.067 4.067 0 00-4.063-4.062zm0 0'
      />
      <path
        d='M25.188 3.25h-3.25a.813.813 0 00-.813.812v4.875a.813.813 0 00.813.813h3.25A.813.813 0 0026 8.937V4.062a.813.813 0 00-.812-.812zm0 0'
        fill='#455a64'
      />
      <path d='M36.563 39H2.438A2.44 2.44 0 010 36.563V2.438A2.44 2.44 0 012.438 0h29.25a.818.818 0 01.575.237l6.5 6.5a.818.818 0 01.237.576v29.25A2.44 2.44 0 0136.563 39zM2.438 1.625a.815.815 0 00-.813.813v34.125a.815.815 0 00.813.813h34.125a.815.815 0 00.813-.813V7.649l-6.024-6.024zm0 0' />
      <path d='M26.813 13H12.188a2.441 2.441 0 01-2.438-2.437V.813A.813.813 0 0110.563 0h17.875a.813.813 0 01.813.813v9.75A2.441 2.441 0 0126.813 13zM11.375 1.625v8.938a.815.815 0 00.813.812h14.625a.815.815 0 00.813-.812V1.625zm0 0M33.313 39.001H5.688a.813.813 0 01-.813-.813v-19.5a4.066 4.066 0 014.063-4.063h21.125a4.066 4.066 0 014.063 4.062v19.5a.813.813 0 01-.813.814zM6.5 37.376h26V18.687a2.441 2.441 0 00-2.438-2.438H8.938A2.441 2.441 0 006.5 18.687zm0 0' />
      <path d='M25.188 9.75h-3.25a.813.813 0 01-.813-.813V4.062a.813.813 0 01.813-.812h3.25a.813.813 0 01.812.812v4.875a.813.813 0 01-.812.813zM22.75 8.125h1.625v-3.25H22.75zm0 0M28.438 22.75H10.563a.813.813 0 110-1.625h17.875a.813.813 0 010 1.625zm0 0M28.438 27.626H10.563a.813.813 0 010-1.625h17.875a.813.813 0 010 1.625zm0 0M28.438 32.501H10.563a.813.813 0 010-1.625h17.875a.813.813 0 010 1.625zm0 0' />
    </svg>
  )
}

const Progress2 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 44.881 45.082' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#95c123}.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M43.674 7.151zM35.837.972l.084.026zM43.74 7.289q.025.061.045.123a1.395 1.395 0 00-.045-.123zM43.252 6.654l-4.508-3.565 4.508 3.565zM43.592 7.017c.021.03.039.061.057.092a1.27 1.27 0 00-.057-.092zM37.075 7.721a1.439 1.439 0 01-1.536-1.315v-5.5a2.175 2.175 0 00-.319-.024H17.178a2.14 2.14 0 00-2.285 1.956v19.733c6.431.518 11.464 5.151 11.464 10.791a9.384 9.384 0 01-.387 2.667h15.6a2.14 2.14 0 002.285-1.956V7.829a1.374 1.374 0 00-.026-.254 1.372 1.372 0 01.02.147h-6.77zM36.326 1.192l.042.027zM35.688.937l.092.023zM43.791 7.431a1.392 1.392 0 01.034.136 1.59 1.59 0 00-.034-.136zM36.047 1.047l.056.026zM36.187 1.113l.053.029zM43.38 6.767l.05.052-.05-.052zM35.538.905c.034.005.067.012.1.018-.033-.006-.066-.013-.1-.018zM43.494 6.889c.02.024.039.049.057.074-.02-.025-.037-.05-.057-.074z'
      />
      <path
        className='prefix__a'
        d='M14.894 22.571c-.4-.032-.8-.049-1.2-.049-6.994 0-12.664 4.853-12.664 10.84s5.67 10.84 12.664 10.84c5.919 0 10.89-3.476 12.278-8.173a9.387 9.387 0 00.387-2.667c-.001-5.64-5.034-10.274-11.465-10.791zm-1.293 18.436c-4.882 0-8.84-3.387-8.84-7.566s3.958-7.566 8.84-7.566 8.84 3.387 8.84 7.566-3.958 7.566-8.84 7.566z'
      />
      <ellipse
        className='prefix__b'
        cx={8.84}
        cy={7.566}
        rx={8.84}
        ry={7.566}
        transform='translate(4.761 25.874)'
      />
      <path
        className='prefix__b'
        d='M43.791 7.427l-.006-.018q-.02-.062-.045-.123l-.013-.03a1.35 1.35 0 00-.053-.108l-.024-.042c-.018-.031-.037-.062-.057-.092s-.027-.036-.04-.054-.037-.05-.057-.074-.043-.047-.064-.07-.032-.036-.05-.052q-.061-.059-.128-.113l-4.508-3.565-2.254-1.782a1.482 1.482 0 00-.121-.087l-.042-.027q-.042-.027-.086-.051l-.053-.029-.084-.04-.056-.026a2.348 2.348 0 00-.126-.048L35.84.97l-.056-.016-.092-.023-.049-.01a1.749 1.749 0 00-.1-.018v5.5a1.439 1.439 0 001.536 1.315h6.771a1.38 1.38 0 00-.02-.147v-.008c-.015-.043-.026-.088-.039-.136z'
      />
      <path d='M44.825 7.355l-.018-.072a2.2 2.2 0 00-.088-.272l-.021-.051-.018-.039a1.522 1.522 0 00-.039-.082l-.011-.021-.052-.1-.007-.012q-.03-.051-.063-.1l-.007-.006q-.034-.051-.07-.1l-.006-.008-.075-.1-.008-.01q-.038-.045-.078-.089l-.012-.014q-.038-.041-.079-.081l-.017-.017a2.949 2.949 0 00-.082-.076l-.018-.017A3.05 3.05 0 0043.951 6l-3.383-2.668-3.38-2.673c-.051-.037-.095-.072-.144-.106l-.03-.021a2.951 2.951 0 00-.322-.189l-.01-.005c-.068-.038-.139-.064-.211-.094l-.043-.017q-.1-.038-.2-.07l-.02-.007a3.282 3.282 0 00-.488-.111h-.012A3.4 3.4 0 0035.22 0H17.178a3.107 3.107 0 00-3.314 2.836v18.807h-.171C6.143 21.643 0 26.901 0 33.363s6.143 11.72 13.693 11.72c6.106 0 11.291-3.439 13.052-8.173h14.822a3.107 3.107 0 003.314-2.836V7.828a2.083 2.083 0 00-.026-.31c0-.013 0-.026-.006-.039-.007-.042-.012-.079-.024-.124zm-2.852-.515h-4.9a.476.476 0 01-.508-.434v-3.84zM25.137 35.148a8.786 8.786 0 01-.576 1.761c-1.674 3.745-5.916 6.412-10.872 6.412-6.416 0-11.636-4.468-11.636-9.959S7.277 23.4 13.693 23.4h.171a13.527 13.527 0 012.057.182c5.353.893 9.407 4.936 9.407 9.775a8.585 8.585 0 01-.191 1.791zm17.682-1.075a1.178 1.178 0 01-1.256 1.075H27.228a10.105 10.105 0 00.159-1.786c0-5.813-4.97-10.65-11.464-11.564V2.836a1.178 1.178 0 011.256-1.075H34.51v4.645a2.4 2.4 0 002.565 2.2h5.748v25.466z' />
      <path d='M15.922 25.232a11.414 11.414 0 00-2.057-.234h-.264c-5.441 0-9.868 3.789-9.868 8.446a7.543 7.543 0 001.4 4.345 1.131 1.131 0 001.412.3.813.813 0 00.352-1.208 5.967 5.967 0 01-1.11-3.438c0-3.686 3.5-6.685 7.811-6.685.088 0 .176 0 .264.006a8.977 8.977 0 012.057.3c3.177.848 5.49 3.389 5.49 6.384a5.77 5.77 0 01-.259 1.707 6.183 6.183 0 01-.876 1.761 8.161 8.161 0 01-6.675 3.217 9.219 9.219 0 01-1.075-.063 1.013 1.013 0 00-1.159.752.915.915 0 00.879.992 11.627 11.627 0 001.356.079 10.076 10.076 0 009-4.978 7.557 7.557 0 00.668-1.761 7.279 7.279 0 00.2-1.707c.001-3.98-3.221-7.32-7.546-8.215zM21.702 10.985a.891.891 0 100 1.761h15.353a.891.891 0 100-1.761zM33.967 17.469a.963.963 0 00-1.029-.881H21.702a.891.891 0 100 1.761h11.237a.963.963 0 001.028-.88zM37.051 22.192h-9.916a.891.891 0 100 1.761h9.916a.891.891 0 100-1.761zM37.053 27.795h-7.166a.891.891 0 100 1.761h7.166a.891.891 0 100-1.761z' />
      <path d='M13.601 34.321h3.456a.891.891 0 100-1.761h-2.863l-.329-.485-2.065-3.048a1.129 1.129 0 00-1.406-.32.815.815 0 00-.374 1.2l2.691 3.972a1.071 1.071 0 00.89.442zM9.599 39.373a.843.843 0 00-.095-.152.887.887 0 00-.128-.134.971.971 0 00-.156-.109 1.148 1.148 0 00-.37-.131 1.187 1.187 0 00-.4 0 1.136 1.136 0 00-.192.05 1.115 1.115 0 00-.177.081.972.972 0 00-.156.109.889.889 0 00-.129.134.835.835 0 00-.095.152.8.8 0 00-.059.165.747.747 0 00-.02.172.765.765 0 00.02.173.834.834 0 00.059.165.858.858 0 00.095.151.889.889 0 00.129.134.975.975 0 00.156.109 1.115 1.115 0 00.177.081 1.136 1.136 0 00.192.05 1.2 1.2 0 00.2.018 1.174 1.174 0 00.2-.018 1.148 1.148 0 00.37-.131.975.975 0 00.156-.109.887.887 0 00.128-.134.867.867 0 00.095-.151.84.84 0 00.059-.165.761.761 0 00.02-.173.748.748 0 00-.02-.172.8.8 0 00-.059-.165zM38.003 17.086a.836.836 0 00-.095-.152.881.881 0 00-.127-.134.974.974 0 00-.156-.109 1.127 1.127 0 00-.178-.081 1.175 1.175 0 00-.192-.05 1.187 1.187 0 00-.4 0 1.147 1.147 0 00-.37.131 1.01 1.01 0 00-.155.109.888.888 0 00-.129.134.841.841 0 00-.095.152.793.793 0 00-.059.165.743.743 0 00-.02.172.759.759 0 00.02.173.83.83 0 00.059.165.866.866 0 00.095.151.89.89 0 00.129.134 1.08 1.08 0 00.155.11 1.146 1.146 0 00.37.131 1.2 1.2 0 00.2.017 1.165 1.165 0 00.393-.067 1.125 1.125 0 00.178-.081 1.037 1.037 0 00.156-.11.882.882 0 00.127-.134.861.861 0 00.095-.151.837.837 0 00.059-.165.761.761 0 00.021-.173.748.748 0 00-.021-.172.794.794 0 00-.06-.165z' />
    </svg>
  )
}
const Progress2Grey = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 44.881 45.082' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#adadad}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M44.855 7.518c0-.013 0-.026-.006-.039a2.708 2.708 0 00-.024-.124l-.018-.072a2.2 2.2 0 00-.088-.272l-.021-.051-.018-.039a1.522 1.522 0 00-.039-.082l-.011-.021-.052-.1-.007-.012q-.03-.051-.063-.1l-.007-.006q-.034-.051-.07-.1l-.006-.008-.075-.1-.008-.01q-.038-.045-.078-.089l-.012-.014q-.038-.041-.079-.081l-.017-.017a2.949 2.949 0 00-.082-.076l-.018-.017A3.05 3.05 0 0043.951 6l-3.382-2.668L37.188.659c-.051-.037-.095-.072-.143-.106l-.03-.021a2.952 2.952 0 00-.322-.189l-.01-.005c-.069-.038-.14-.064-.211-.094l-.043-.017q-.1-.038-.2-.07l-.02-.007a3.282 3.282 0 00-.488-.111h-.012A3.4 3.4 0 0035.22 0H17.179a3.107 3.107 0 00-3.314 2.836v18.807h-.171c-7.551 0-13.693 5.258-13.693 11.72s6.143 11.72 13.693 11.72c6.106 0 11.291-3.439 13.052-8.173h14.822a3.107 3.107 0 003.314-2.836V7.828a2.081 2.081 0 00-.027-.31zm-8.287-4.952l5.405 4.274h-4.9a.476.476 0 01-.508-.434zM25.137 35.148a8.785 8.785 0 01-.576 1.761c-1.674 3.745-5.916 6.412-10.872 6.412-6.416 0-11.636-4.468-11.636-9.959S7.277 23.4 13.693 23.4h.171a13.528 13.528 0 012.057.182c5.353.893 9.407 4.936 9.407 9.775a8.584 8.584 0 01-.191 1.791zm17.682-1.075a1.178 1.178 0 01-1.256 1.075H27.228a10.105 10.105 0 00.159-1.786c0-5.813-4.97-10.65-11.464-11.564V2.836a1.178 1.178 0 011.256-1.075H34.51v4.645a2.4 2.4 0 002.565 2.2h5.748z'
      />
      <path
        className='prefix__a'
        d='M15.922 25.232a11.417 11.417 0 00-2.057-.234h-.264c-5.442 0-9.868 3.789-9.868 8.447a7.542 7.542 0 001.4 4.345 1.131 1.131 0 001.412.3.813.813 0 00.352-1.208 5.967 5.967 0 01-1.11-3.438c0-3.686 3.5-6.685 7.811-6.685.088 0 .176 0 .264.006a8.976 8.976 0 012.057.3c3.177.848 5.49 3.389 5.49 6.384a5.769 5.769 0 01-.259 1.707 6.184 6.184 0 01-.876 1.761 8.161 8.161 0 01-6.675 3.217 9.226 9.226 0 01-1.075-.063 1.013 1.013 0 00-1.159.752.915.915 0 00.879.992 11.628 11.628 0 001.356.079 10.076 10.076 0 009-4.978 7.556 7.556 0 00.668-1.761 7.278 7.278 0 00.2-1.707c.001-3.981-3.221-7.321-7.546-8.216zM21.702 10.985a.891.891 0 100 1.761h15.353a.891.891 0 100-1.761zM33.967 17.468a.963.963 0 00-1.029-.88H21.702a.891.891 0 100 1.761h11.237a.963.963 0 001.028-.881zM37.051 22.192h-9.916a.891.891 0 100 1.761h9.916a.891.891 0 100-1.761zM37.054 27.795h-7.166a.891.891 0 100 1.761h7.166a.891.891 0 100-1.761z'
      />
      <path
        className='prefix__a'
        d='M13.601 34.321h3.456a.891.891 0 100-1.761h-2.863l-.329-.485-2.065-3.048a1.128 1.128 0 00-1.406-.32.815.815 0 00-.374 1.2l2.691 3.972a1.071 1.071 0 00.89.442zM9.598 39.373a.843.843 0 00-.095-.152.885.885 0 00-.128-.134.97.97 0 00-.156-.109 1.148 1.148 0 00-.37-.131 1.185 1.185 0 00-.4 0 1.139 1.139 0 00-.192.05 1.116 1.116 0 00-.177.081.97.97 0 00-.156.109.887.887 0 00-.129.134.838.838 0 00-.095.152.8.8 0 00-.059.165.746.746 0 00-.02.172.764.764 0 00.02.173.833.833 0 00.059.165.859.859 0 00.095.151.886.886 0 00.129.134.97.97 0 00.156.109 1.119 1.119 0 00.177.081 1.139 1.139 0 00.192.05 1.2 1.2 0 00.2.018 1.178 1.178 0 00.2-.018 1.148 1.148 0 00.37-.131.97.97 0 00.156-.109.884.884 0 00.128-.134.865.865 0 00.095-.151.841.841 0 00.059-.165.76.76 0 00.02-.173.747.747 0 00-.02-.172.8.8 0 00-.059-.165zM38.003 17.086a.829.829 0 00-.095-.152.879.879 0 00-.127-.134.975.975 0 00-.157-.109 1.126 1.126 0 00-.178-.081 1.182 1.182 0 00-.787 0 1.168 1.168 0 00-.178.081 1.008 1.008 0 00-.155.109.893.893 0 00-.129.134.837.837 0 00-.095.152.792.792 0 00-.059.165.741.741 0 00-.02.172.754.754 0 00.02.173.83.83 0 00.059.165.861.861 0 00.095.151.89.89 0 00.129.134 1.079 1.079 0 00.155.11 1.147 1.147 0 00.37.131 1.2 1.2 0 00.2.017 1.165 1.165 0 00.393-.067 1.121 1.121 0 00.178-.081 1.041 1.041 0 00.157-.11.877.877 0 00.127-.134.853.853 0 00.095-.151.834.834 0 00.059-.165.759.759 0 00.021-.173.746.746 0 00-.021-.172.789.789 0 00-.057-.165z'
      />
    </svg>
  )
}

const Progress3 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 36.881 40.234' {...props}>
      <defs>
        <style>{'.prefix__a{fill:#95c123}.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M4.024 3.353A2.682 2.682 0 016.706.671h26.818a2.682 2.682 0 012.682 2.682v26.818l-8.042 8.051H6.706a2.682 2.682 0 01-2.682-2.682z'
      />
      <path
        className='prefix__b'
        d='M33.528.671h-2.012a2.682 2.682 0 012.682 2.682v26.818l-8.046 8.051h2.012l8.046-8.051V3.353A2.682 2.682 0 0033.528.671zM17.636 20.788l.846-1.175a2.012 2.012 0 013.266 2.351L9.678 38.727a2.012 2.012 0 01-1.471.829 1.271 1.271 0 01-.16.007 2.012 2.012 0 01-1.422-.587L1.26 33.609a2.012 2.012 0 112.845-2.845l3.692 3.692 7.91-10.986'
      />
      <path
        className='prefix__a'
        d='M2.093 30.766l3.692 3.691.842-1.169-2.522-2.522a2.006 2.006 0 00-2.428-.312 2 2 0 01.416.311zM21.292 19.155a2.012 2.012 0 00-2.188-.1c.058.034.12.062.176.1a2.012 2.012 0 01.457 2.808L7.668 38.727a2.006 2.006 0 01-.622.56 2 2 0 001 .276 1.319 1.319 0 00.162-.007 2.012 2.012 0 001.471-.829l12.07-16.764a2.012 2.012 0 00-.457-2.808z'
      />
      <path
        className='prefix__b'
        d='M28.164 38.223v-5.365a2.682 2.682 0 012.682-2.682h5.364'
      />
      <path d='M36.881 3.353A3.357 3.357 0 0033.528 0H6.706a3.357 3.357 0 00-3.353 3.353v23.47a.671.671 0 001.341 0V3.353a2.012 2.012 0 012.012-2.012h26.822a2.012 2.012 0 012.012 2.012V29.5h-4.694a3.357 3.357 0 00-3.353 3.353v4.694h-12.74a.671.671 0 100 1.341h13.411a.671.671 0 00.474-.2l8.047-8.047a.671.671 0 00.2-.474zm-6.035 27.493h3.746L28.834 36.6v-3.743a2.012 2.012 0 012.012-2.011z' />
      <path d='M0 32.187a2.663 2.663 0 00.786 1.9l5.364 5.361a2.667 2.667 0 001.9.786 1.8 1.8 0 00.216-.009 2.678 2.678 0 001.957-1.108l12.07-16.764a2.682 2.682 0 10-4.353-3.136l-.846 1.175a.671.671 0 101.088.783L19.028 20a1.341 1.341 0 112.177 1.566L9.135 38.335a1.335 1.335 0 01-.979.553A1.352 1.352 0 017.1 38.5l-5.366-5.365a1.341 1.341 0 010-1.9 1.373 1.373 0 011.9 0l3.692 3.691a.662.662 0 00.528.194.671.671 0 00.49-.276l7.913-10.987a.671.671 0 10-1.088-.783L7.711 33.425l-3.132-3.134a2.749 2.749 0 00-3.793 0A2.663 2.663 0 000 32.187zM9.388 4.023H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM32.187 4.023H12.071a.671.671 0 100 1.341h20.116a.671.671 0 100-1.341zM9.388 8.047H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM12.071 9.388h15.422a.671.671 0 100-1.341H12.071a.671.671 0 100 1.341zM9.388 12.07H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM12.071 13.411H22.8a.671.671 0 100-1.341H12.071a.671.671 0 100 1.341zM34.199 14.082a.671.671 0 10-1.341 0v9.388a.671.671 0 101.341 0zM33.529 25.481a.671.671 0 00-.671.671v1.341a.671.671 0 001.341 0v-1.341a.671.671 0 00-.67-.671z' />
    </svg>
  )
}

const Progress3Red = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 36.881 40.234' {...props}>
      <defs>
        <style>{'.prefix__a{fill:red}.prefix__b{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M4.024 3.353A2.682 2.682 0 016.706.671h26.818a2.682 2.682 0 012.682 2.682v26.818l-8.042 8.051H6.706a2.682 2.682 0 01-2.682-2.682z'
      />
      <path
        className='prefix__b'
        d='M33.528.671h-2.012a2.682 2.682 0 012.682 2.682v26.818l-8.046 8.051h2.012l8.046-8.051V3.353A2.682 2.682 0 0033.528.671zM17.636 20.788l.846-1.175a2.012 2.012 0 013.266 2.351L9.678 38.727a2.012 2.012 0 01-1.471.829 1.271 1.271 0 01-.16.007 2.012 2.012 0 01-1.422-.587L1.26 33.609a2.012 2.012 0 112.845-2.845l3.692 3.692 7.91-10.986'
      />
      <path
        className='prefix__a'
        d='M2.093 30.766l3.692 3.691.842-1.169-2.522-2.522a2.006 2.006 0 00-2.428-.312 2 2 0 01.416.311zM21.292 19.155a2.012 2.012 0 00-2.188-.1c.058.034.12.062.176.1a2.012 2.012 0 01.457 2.808L7.668 38.727a2.006 2.006 0 01-.622.56 2 2 0 001 .276 1.319 1.319 0 00.162-.007 2.012 2.012 0 001.471-.829l12.07-16.764a2.012 2.012 0 00-.457-2.808z'
      />
      <path
        className='prefix__b'
        d='M28.164 38.223v-5.365a2.682 2.682 0 012.682-2.682h5.364'
      />
      <path d='M36.881 3.353A3.357 3.357 0 0033.528 0H6.706a3.357 3.357 0 00-3.353 3.353v23.47a.671.671 0 001.341 0V3.353a2.012 2.012 0 012.012-2.012h26.822a2.012 2.012 0 012.012 2.012V29.5h-4.694a3.357 3.357 0 00-3.353 3.353v4.694h-12.74a.671.671 0 100 1.341h13.411a.671.671 0 00.474-.2l8.047-8.047a.671.671 0 00.2-.474zm-6.035 27.493h3.746L28.834 36.6v-3.743a2.012 2.012 0 012.012-2.011z' />
      <path d='M0 32.187a2.663 2.663 0 00.786 1.9l5.364 5.361a2.667 2.667 0 001.9.786 1.8 1.8 0 00.216-.009 2.678 2.678 0 001.957-1.108l12.07-16.764a2.682 2.682 0 10-4.353-3.136l-.846 1.175a.671.671 0 101.088.783L19.028 20a1.341 1.341 0 112.177 1.566L9.135 38.335a1.335 1.335 0 01-.979.553A1.352 1.352 0 017.1 38.5l-5.366-5.365a1.341 1.341 0 010-1.9 1.373 1.373 0 011.9 0l3.692 3.691a.662.662 0 00.528.194.671.671 0 00.49-.276l7.913-10.987a.671.671 0 10-1.088-.783L7.711 33.425l-3.132-3.134a2.749 2.749 0 00-3.793 0A2.663 2.663 0 000 32.187zM9.388 4.023H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM32.187 4.023H12.071a.671.671 0 100 1.341h20.116a.671.671 0 100-1.341zM9.388 8.047H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM12.071 9.388h15.422a.671.671 0 100-1.341H12.071a.671.671 0 100 1.341zM9.388 12.07H8.047a.671.671 0 000 1.341h1.341a.671.671 0 100-1.341zM12.071 13.411H22.8a.671.671 0 100-1.341H12.071a.671.671 0 100 1.341zM34.199 14.082a.671.671 0 10-1.341 0v9.388a.671.671 0 101.341 0zM33.529 25.481a.671.671 0 00-.671.671v1.341a.671.671 0 001.341 0v-1.341a.671.671 0 00-.67-.671z' />
    </svg>
  )
}

const Progress4 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 43.792 44.766' {...props}>
      <defs>
        <style>{'.prefix__a{fill:rgba(52,52,52,.4)}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M11.191 13.138h21.41v1.946h-21.41zM30.655 16.057h1.946v1.946h-1.946zM11.191 16.057h1.946v1.946h-1.946zM20.923 6.812h1.946v1.946h-1.946zM23.843 6.812h1.946v1.946h-1.946zM18.003 6.812h1.946v1.946h-1.946zM15.084 6.812h1.946v1.946h-1.946zM26.762 6.812h1.946v1.946h-1.946z'
      />
      <path
        className='prefix__a'
        d='M39.685 41.961a5.786 5.786 0 01-3.138.858l5.736-17.209a.973.973 0 00-.524-1.2l-5.265-2.369v-9.39a2.923 2.923 0 00-2.919-2.919h-1.46V4.866a.973.973 0 00-.973-.973h-8.273V0h-1.946v3.893h-8.272a.973.973 0 00-.973.973v4.866h-1.46a2.923 2.923 0 00-2.919 2.919v9.394l-5.266 2.37a.973.973 0 00-.524 1.2l5.736 17.208a5.786 5.786 0 01-3.138-.858A7.68 7.68 0 000 40.877v1.946a5.791 5.791 0 013.191.859 7.678 7.678 0 004.107 1.088 8.07 8.07 0 001.427-.11 7.889 7.889 0 002.68-.98 5.781 5.781 0 013.182-.856 5.791 5.791 0 013.191.859 7.678 7.678 0 004.107 1.088 7.68 7.68 0 004.107-1.088 6.37 6.37 0 016.384 0 7.928 7.928 0 002.689.979 8.057 8.057 0 001.427.11 7.68 7.68 0 004.107-1.088 5.791 5.791 0 013.191-.859v-1.952a7.677 7.677 0 00-4.105 1.088zm.473-16.132l-.7 2.093L22.869 20.3v-2.25zM13.624 5.839h16.544v3.893H13.624zm-4.379 6.812a.974.974 0 01.973-.973h23.356a.974.974 0 01.973.973v8.519l-12.252-5.514a.972.972 0 00-.8 0l-12.25 5.513v-8.518zM3.633 25.829l17.289-7.78V20.3L4.333 27.922zm30.953 16.718a7.9 7.9 0 01-1.295-.59 8.309 8.309 0 00-8.213 0 5.792 5.792 0 01-3.191.859 5.79 5.79 0 01-3.191-.859 7.679 7.679 0 00-4.107-1.088 7.668 7.668 0 00-4.1 1.085 7.872 7.872 0 01-1.284.587L4.951 29.78l15.972-7.339v11.62h1.946v-11.62l15.972 7.339z'
      />
    </svg>
  )
}

const Progress5 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 41.001 41.001' {...props}>
      <defs>
        <style>{'.prefix__a{fill:rgba(52,52,52,.4)}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M12.493 29.628a.8.8 0 10.8.8.8.8 0 00-.8-.8z'
      />
      <path
        className='prefix__a'
        d='M36.047 15.215l4.719-4.717a.8.8 0 00-.33-1.331L28.945 5.618a8.009 8.009 0 00-15.072-.6L.562 9.165a.8.8 0 00-.328 1.333l4.843 4.843-3.054 5.09a.8.8 0 00.433 1.167l4.43 1.477v12.323a.8.8 0 00.52.75c2.709 1.016 12.774 4.791 12.828 4.81a.8.8 0 00.512.007h.007l14.415-4.8a.8.8 0 00.548-.76V22.749l4.725-1.485a.8.8 0 00.326-1.33zm-6.738-7.207c0-.2-.009-.406-.024-.609l9.409 2.9-4 4-6.524-2.176a8.031 8.031 0 001.139-4.115zM15.241 5.924a6.406 6.406 0 0112.466 2.084 6.406 6.406 0 01-6.407 6.407 6.412 6.412 0 01-6.06-8.491zM2.3 10.298l11.078-3.451a8.074 8.074 0 00-.085 1.161 7.96 7.96 0 00.888 3.665L6.3 14.298zm1.61 10.1l2.532-4.22L19.3 20.464l-2.532 4.22zM19.7 39.045l-11.211-4.2V23.613c8.821 2.925 8.39 2.835 8.636 2.835a.8.8 0 00.687-.389l1.888-3.148zm.8-19.869L8.618 15.215l6.47-2.157a8.006 8.006 0 0012.066.414l5.228 1.742zm13.614 15.642L21.3 39.089V22.298l2.839 3.548a.8.8 0 00.865.264l9.109-2.862zm-9.066-10.4l-3.205-4.006 12.857-4.28 4 4z'
      />
      <path
        className='prefix__a'
        d='M17.578 31.407l-1.781-.668a.8.8 0 00-.562 1.5l1.781.668a.8.8 0 10.562-1.5zM17.578 34.828l-4.8-1.8a.8.8 0 10-.562 1.5l4.8 1.8a.8.8 0 00.562-1.5zM25.872 5.039a.8.8 0 00-1.133 0L20.5 9.278l-1.035-1.035a.801.801 0 10-1.133 1.133l1.6 1.6a.8.8 0 001.133 0l4.8-4.8a.8.8 0 00.007-1.137z'
      />
    </svg>
  )
}

const Progress6 = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 43.996 41.001' {...props}>
      <defs>
        <style>{'.prefix__a{fill:rgba(52,52,52,.4)}'}</style>
      </defs>
      <path
        className='prefix__a'
        d='M41.317 17.666H39.1a2.185 2.185 0 00-2.086-1.6h-2.369v-5.794a.611.611 0 00-.3-.54L17.641.083a.617.617 0 00-.62 0L.31 9.732a.622.622 0 00-.31.54v19.294a.623.623 0 00.312.54l16.713 9.649a.623.623 0 00.312.084.656.656 0 00.321-.084l8.794-5.073v3.667a2.64 2.64 0 002.662 2.647h12.2A2.655 2.655 0 0044 38.354v-18a2.69 2.69 0 00-2.683-2.688zm-4.282-.356a.9.9 0 01.9.9v.06a.9.9 0 01-.9.9h-3.623a.9.9 0 01-.9-.9v-.06a.9.9 0 01.9-.9zm-19.7-15.967l6.944 4.009-15.463 8.929-6.944-4.009zm-.593 36.8l-15.5-8.929V11.351l15.5 8.929zm.593-18.94l-7.273-4.2 15.465-8.928 7.274 4.2zm9.115 1.154v12.89l-8.46 4.893V20.28l15.41-8.929v4.715h.019a2.185 2.185 0 00-2.086 1.6h-2.22a2.675 2.675 0 00-2.662 2.689zm16.3 18a1.407 1.407 0 01-1.432 1.4h-12.2a1.392 1.392 0 01-1.415-1.4v-18a1.427 1.427 0 011.415-1.441h2.243a2.132 2.132 0 002.061 1.514h3.6a2.132 2.132 0 002.061-1.514h2.243a1.442 1.442 0 011.432 1.441z'
      />
      <path
        className='prefix__a'
        d='M29.831 26.662h.653a.624.624 0 100-1.247h-.025v-1.692h1.72a.6.6 0 00.593.421.625.625 0 00.627-.622v-.42a.632.632 0 00-.63-.626h-2.937a.622.622 0 00-.619.626v2.937a.619.619 0 00.619.623zM29.835 32.362h2.939a.623.623 0 00.623-.623V28.8a.623.623 0 00-.623-.623h-2.939a.623.623 0 00-.623.623v2.939a.623.623 0 00.623.623zm.623-2.939h1.692v1.692h-1.692zM30.484 36.815h-.025v-1.692h1.686a.627.627 0 101.253 0v-.6a.65.65 0 00-.63-.647h-2.937a.64.64 0 00-.619.647v2.937a.6.6 0 00.619.6h.653a.624.624 0 100-1.247z'
      />
      <path
        className='prefix__a'
        d='M34.203 23.242l-1.826 1.826-.555-.556a.624.624 0 00-.882.882l1 1a.623.623 0 00.882 0l2.267-2.267a.624.624 0 00-.882-.882zM34.203 34.753l-1.826 1.826-.555-.555a.624.624 0 10-.882.882l1 1a.623.623 0 00.882 0l2.267-2.267a.624.624 0 00-.882-.882zM40.599 23.99h-3.916a.624.624 0 000 1.247h3.916a.624.624 0 100-1.247zM40.599 29.69h-3.916a.624.624 0 000 1.247h3.916a.624.624 0 100-1.247zM40.599 35.39h-3.916a.624.624 0 000 1.247h3.916a.624.624 0 100-1.247z'
      />
    </svg>
  )
}

const CloudIcon = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 19.979 19.979' {...props}>
      <path d='M0 0h19.979v19.979H0z' fill='none' />
      <path
        d='M16.108 8.277A6.321 6.321 0 009.989 3a6.212 6.212 0 00-5.535 3.53A5.151 5.151 0 000 11.737a5.127 5.127 0 004.995 5.242h10.821a4.271 4.271 0 004.162-4.368 4.265 4.265 0 00-3.87-4.334zm-1.956 2.586l-4.163 4.368-4.162-4.368h2.5V7.368h3.33v3.495z'
        fill='#0a81ad'
      />
    </svg>
  )
}

const DocxIcon = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24.587 30.904'>
      <defs>
        <linearGradient
          id={`prefix__docx_a_${props.dataIndex + 1}`}
          x1={0.5}
          x2={0.5}
          y2={1}
          gradientUnits='objectBoundingBox'
        >
          <stop offset={0} stopColor='#5895ff' />
          <stop offset={1} stopColor='#387cf4' />
        </linearGradient>
        <filter
          id={`prefix__docx_b_${props.dataIndex + 1}`}
          x={9.952}
          y={0}
          width={14.635}
          height={14.635}
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy={-2} />
          <feGaussianBlur stdDeviation={1} result='c' />
          <feFlood floodOpacity={0.09} />
          <feComposite operator='in' in2='c' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <path
        d='M12.952 0l8.635 8.635v14.247a3.022 3.022 0 01-3.022 3.018H3.022A3.022 3.022 0 010 22.882V3.022A3.022 3.022 0 013.022 0z'
        fill={`url(#prefix__docx_a_${props.dataIndex + 1})`}
        transform='translate(0 5)'
      />
      <g filter={`url(#prefix__docx_a_${props.dataIndex + 1})`}>
        <path
          d='M21.59 13.63h-5.46a3.289 3.289 0 01-3.175-3.175v-5.46z'
          fill='rgba(255,255,255,.4)'
        />
      </g>
      <path
        d='M3.671 24.904v-1.143h4.5v1.143zm0-2.286v-1.143h9v1.143zm0-2.285V19.19h9v1.143zm0-2.286v-1.143h9v1.143z'
        fill='#fff'
      />
    </svg>
  )
}

const XlsxIcon = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24.587 30.904'>
      <defs>
        <linearGradient
          id={`prefix__xlsx_a_${props.dataIndex + 1}`}
          x1={0.5}
          x2={0.5}
          y2={1}
          gradientUnits='objectBoundingBox'
        >
          <stop offset={0} stopColor='#1abf74' />
          <stop offset={1} stopColor='#009f57' />
        </linearGradient>
        <filter
          id={`prefix__xlsx_a_${props.dataIndex + 1}`}
          x={9.952}
          y={0}
          width={14.635}
          height={14.635}
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy={-2} />
          <feGaussianBlur stdDeviation={1} result='c' />
          <feFlood floodOpacity={0.09} />
          <feComposite operator='in' in2='c' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <path
        d='M12.952 0l8.635 8.635v14.247a3.022 3.022 0 01-3.022 3.018H3.022A3.022 3.022 0 010 22.882V3.022A3.022 3.022 0 013.022 0z'
        fill={`url(#prefix__xlsx_a_${props.dataIndex + 1})`}
        transform='translate(0 5)'
      />
      <g filter={`url(#prefix__xlsx_a_${props.dataIndex + 1})`}>
        <path
          d='M21.59 13.63h-5.46a3.289 3.289 0 01-3.175-3.175v-5.46z'
          fill='rgba(255,255,255,.4)'
        />
      </g>
      <g>
        <path
          d='M12.946 24.428H4.32v-8.631h8.624v8.631zm-.718-.72v-2.171h-2.161v2.171zm-2.88 0v-2.171H7.926v2.171zm-2.141 0v-2.171H5.041v2.171zm5.021-2.89v-2.171h-2.161v2.171zm-2.88 0v-2.171H7.926v2.171zm-2.141 0v-2.171H5.041v2.171zm5.021-2.89v-1.412H5.041v1.412z'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

const PdfIcon = (props) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24.587 30.904'>
      <defs>
        <filter
          id={`prefix__pdf_a_${props.dataIndex + 1}`}
          x={9.952}
          y={0}
          width={14.635}
          height={14.635}
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy={-2} />
          <feGaussianBlur stdDeviation={1} result='b' />
          <feFlood floodOpacity={0.09} />
          <feComposite operator='in' in2='b' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <path
        d='M12.952 5l8.635 8.635v14.247a3.022 3.022 0 01-3.022 3.018H3.022A3.022 3.022 0 010 27.882V8.022A3.022 3.022 0 013.022 5z'
        fill='#e94848'
      />
      <path
        d='M6.052 21.904a1.013 1.013 0 01.287-.709l.022-.025a9.51 9.51 0 012.25-1.035 19.626 19.626 0 001.119-2.906 5.886 5.886 0 01-.778-2.325 1 1 0 112 0 8.6 8.6 0 01-.575 2.269 7.408 7.408 0 001.45 1.887 8.039 8.039 0 012.225-.456 1 1 0 110 2 4.081 4.081 0 01-2.378-.875 20.7 20.7 0 00-2.71.916 12.994 12.994 0 01-1.181 1.953l-.019.016a.991.991 0 01-.712.29 1 1 0 01-1-1z'
        fill='#fff'
      />
      <g filter={`url(#prefix__pdf_a_${props.dataIndex + 1})`}>
        <path
          d='M21.59 13.63h-5.46a3.289 3.289 0 01-3.175-3.175v-5.46z'
          fill='rgba(255,255,255,.4)'
        />
      </g>
    </svg>
  )
}

const VesselIcon = (props) => {
  const { dataIndex = 0, fill = '#57ff38' } = props
  return (
    <svg width='2em' height='2em' viewBox='0 0 15.967 22.166'>
      <defs>
        <clipPath id={`prefix__vessel_a${dataIndex}`}>
          <path className={`prefix__vessel_a${dataIndex}`} d='M0 0h10v20H0z' />
        </clipPath>
        <clipPath id={`prefix__b${dataIndex}`}>
          <path
            className={`prefix__vessel_a${dataIndex}`}
            d='M4.444 0l4.445 6.857v10.857a.564.564 0 01-.556.571H.556A.564.564 0 010 17.714V6.857z'
          />
        </clipPath>
        <style>{`.prefix__vessel_a${dataIndex}{fill:none}`}</style>
      </defs>
      <path
        d='M5.1 2.709l6.435 5.036 3.535 10.266a.564.564 0 01-.34.72l-7.353 2.533a.564.564 0 01-.712-.36L3.13 10.64z'
        fill={fill}
      />
      <path
        className={`prefix__vessel_a${dataIndex}`}
        d='M0 3.256L9.455 0l6.512 18.91-9.456 3.256z'
      />
      <g
        clipPath={`url(#prefix__vessel_a${dataIndex})`}
        transform='rotate(-19 9.729 1.628)'
      >
        <path
          d='M1.111 20A1.127 1.127 0 010 18.858V7.827l.094-.144L4.538.826 5 1.143l.463-.317 4.444 6.857.093.144v11.031H8.889V8.174L5 2.174l-3.889 6v10.684H10a1.127 1.127 0 01-1.111 1.143zM4.538.826L5 .113l.463.713L5 1.143z'
          fill='#282560'
        />
      </g>
      <path
        className={`prefix__vessel_a${dataIndex}`}
        d='M5.1 2.709l6.435 5.036 3.535 10.266a.564.564 0 01-.34.72l-7.353 2.533a.564.564 0 01-.712-.36L3.13 10.64z'
      />
    </svg>
  )
}

const EquipmentIcon = (props) => (
  <svg
    width={`${props.width}` || '24'}
    height={`${props.height}` || '24'}
    viewBox='0 0 24 24'
    fill={`${props.color || Colors.grey}`}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.041 11.5966C13.2662 11.4814 13.5171 11.4205 13.7774 11.4205C14.2088 11.4205 14.6143 11.588 14.92 11.8921L15.5782 11.234C17.2068 11.8049 19.0905 11.4395 20.3925 10.1375C21.488 9.04203 21.92 7.53476 21.6894 6.114C21.664 5.95753 21.5532 5.82848 21.4024 5.7798C21.2516 5.73104 21.0861 5.77066 20.9741 5.88277L19.9969 6.85996C19.2011 7.65574 17.9108 7.65574 17.115 6.85996C16.3191 6.06418 16.3191 4.77386 17.115 3.97808L18.0922 3.00089C18.2043 2.88878 18.2442 2.72324 18.1954 2.57238C18.1467 2.42146 18.0174 2.31095 17.8609 2.28554C16.4402 2.05491 14.9329 2.48695 13.8374 3.58245C12.5161 4.90378 12.1605 6.82401 12.7682 8.469L11.3408 9.89637L13.041 11.5966Z'
      fill={`${props.color || Colors.grey}`}
    />
    <path
      d='M10.4404 14.183L8.74736 12.49L2.82733 18.41C2.05756 19.1797 2.05756 20.4278 2.82733 21.1975C3.5971 21.9673 4.84514 21.9673 5.61491 21.1975L10.7183 16.0942C10.2036 15.5767 10.1108 14.7954 10.4404 14.183Z'
      fill={`${props.color || Colors.grey}`}
    />
    <path
      d='M14.2165 12.6025C14.0954 12.4815 13.9367 12.4209 13.778 12.4209C13.6194 12.4209 13.4606 12.4815 13.3396 12.6025L12.9862 12.9559L6.69088 6.66062L6.98513 6.36637C7.25324 6.09833 7.21996 5.65369 6.91437 5.42867L4.34588 3.53705C4.09905 3.35531 3.75651 3.38112 3.53976 3.59787L2.44919 4.6885C2.23243 4.90526 2.20662 5.24786 2.38836 5.49463L4.27992 8.06312C4.50494 8.36864 4.94932 8.40225 5.21763 8.13388L5.51188 7.83956L11.8072 14.1349L11.4289 14.5132C11.1867 14.7553 11.1867 15.1479 11.4289 15.39L17.2365 21.1976C18.0063 21.9674 19.2543 21.9674 20.0241 21.1976C20.7938 20.4279 20.7938 19.1798 20.0241 18.41L14.2165 12.6025Z'
      fill={`${props.color || Colors.grey}`}
    />
  </svg>
)

const SearchIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z'
        stroke='#AAAAAA'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21 20.9999L16.65 16.6499'
        stroke='#AAAAAA'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const UnfinalizedWApprovalIcon = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16' cy='16' r='16' fill='#B3FFC3' />
    <path
      d='M11.7461 10.1641H15.2617C15.553 10.1641 15.7891 9.92795 15.7891 9.63672C15.7891 9.34548 15.553 9.10938 15.2617 9.10938H11.7461C11.4549 9.10938 11.2188 9.34548 11.2188 9.63672C11.2188 9.92795 11.4549 10.1641 11.7461 10.1641Z'
      fill='#00B812'
    />
    <path
      d='M9.63672 12.2734H17.3711C17.6623 12.2734 17.8984 12.0373 17.8984 11.7461C17.8984 11.4549 17.6623 11.2188 17.3711 11.2188H9.63672C9.34548 11.2188 9.10938 11.4549 9.10938 11.7461C9.10938 12.0373 9.34548 12.2734 9.63672 12.2734Z'
      fill='#00B812'
    />
    <path
      d='M12.4492 17.5469H9.63672C9.34548 17.5469 9.10938 17.783 9.10938 18.0742C9.10938 18.3655 9.34548 18.6016 9.63672 18.6016H12.4492C12.7405 18.6016 12.9766 18.3655 12.9766 18.0742C12.9766 17.783 12.7405 17.5469 12.4492 17.5469Z'
      fill='#00B812'
    />
    <path
      d='M24.7138 9.73248C25.2149 9.01677 25.041 8.03029 24.3252 7.52917C23.6095 7.02802 22.6231 7.20197 22.1219 7.91768L20.0078 10.937V7.52734C20.0078 7.23611 19.7717 7 19.4805 7H7.52734C7.23611 7 7 7.23611 7 7.52734V23.0664C7 24.1326 7.86741 25 8.93359 25H20.1836C21.2498 25 22.1172 24.1326 22.1172 23.0664V21.6602C22.1172 21.3689 21.8811 21.1328 21.5898 21.1328H20.0078V16.4533L24.7138 9.73248ZM22.9859 8.52262C23.1529 8.28405 23.4817 8.22607 23.7203 8.3931C23.9589 8.56016 24.0169 8.88898 23.8498 9.12755L23.1441 10.1355L22.2801 9.53055L22.9859 8.52262ZM9.8125 21.6602V23.0664C9.8125 23.551 9.41822 23.9453 8.93359 23.9453C8.44896 23.9453 8.05469 23.551 8.05469 23.0664V8.05469H18.9531V12.4432L17.8865 13.9665C17.8942 13.9307 17.8984 13.8936 17.8984 13.8555C17.8984 13.5642 17.6623 13.3281 17.3711 13.3281H9.63672C9.34548 13.3281 9.10938 13.5642 9.10938 13.8555C9.10938 14.1467 9.34548 14.3828 9.63672 14.3828H17.3711C17.4746 14.3828 17.5708 14.3526 17.6523 14.3011L16.8565 15.4375H9.63672C9.34548 15.4375 9.10938 15.6736 9.10938 15.9648C9.10938 16.2561 9.34548 16.4922 9.63672 16.4922H16.3898L15.5759 18.9531H14.207C13.9158 18.9531 13.6797 19.1892 13.6797 19.4805C13.6797 19.7717 13.9158 20.0078 14.207 20.0078H15.9105C16.0346 20.0198 16.1662 19.9872 16.2837 19.8943L18.9531 17.7861V21.1328H10.3398C10.0486 21.1328 9.8125 21.3689 9.8125 21.6602ZM17.9542 17.231L17.0095 17.9772L17.3875 16.8342L17.9542 17.231ZM21.0625 22.1875V23.0664C21.0625 23.551 20.6682 23.9453 20.1836 23.9453H10.6557C10.7908 23.6815 10.8672 23.3827 10.8672 23.0664V22.1875H21.0625ZM18.7078 16.4711L17.8438 15.8662L21.6752 10.3945L22.5391 10.9994L18.7078 16.4711Z'
      fill='#00B812'
    />
  </svg>
)

const UnfinalizedWOApprovalIcon = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16' cy='16' r='16' fill='#FFD7D5' />
    <path
      d='M23.3414 11.6732L18.7023 7.15448C18.6008 7.05555 18.4631 7 18.3195 7H10.4911C9.39318 7 8.5 7.87005 8.5 8.93946V23.0605C8.5 24.13 9.39318 25 10.4911 25H21.5089C22.6068 25 23.5 24.13 23.5 23.0605V12.0461C23.5 11.9062 23.4429 11.7721 23.3414 11.6732ZM18.8609 8.80046L21.6516 11.5187H19.7692C19.2684 11.5187 18.8609 11.1219 18.8609 10.634V8.80046ZM21.5089 23.9453H10.4911C9.99025 23.9453 9.58277 23.5484 9.58277 23.0605V8.93946C9.58277 8.4516 9.99025 8.05469 10.4911 8.05469H17.7781V10.634C17.7781 11.7034 18.6713 12.5734 19.7692 12.5734H22.4172V23.0605C22.4172 23.5484 22.0097 23.9453 21.5089 23.9453Z'
      fill='#FF4D00'
    />
    <path
      d='M16.0009 13.7783C13.4642 13.7783 11.4004 15.7886 11.4004 18.2596C11.4004 20.7305 13.4642 22.7408 16.0009 22.7408C18.5377 22.7408 20.6015 20.7305 20.6015 18.2596C20.6015 15.7886 18.5377 13.7783 16.0009 13.7783ZM16.0009 21.6861C14.0612 21.6861 12.4832 20.1489 12.4832 18.2595C12.4832 16.3701 14.0612 14.833 16.0009 14.833C17.9407 14.833 19.5188 16.3701 19.5188 18.2595C19.5188 20.1489 17.9407 21.6861 16.0009 21.6861Z'
      fill='#FF4D00'
    />
    <path
      d='M17.613 16.6886C17.4015 16.4827 17.0588 16.4827 16.8473 16.6886L16 17.514L15.1527 16.6886C14.9413 16.4827 14.5985 16.4827 14.3871 16.6886C14.1757 16.8945 14.1757 17.2285 14.3871 17.4344L15.2344 18.2597L14.3871 19.0851C14.1757 19.291 14.1757 19.6249 14.3871 19.8308C14.4928 19.9338 14.6313 19.9853 14.7699 19.9853C14.9084 19.9853 15.047 19.9338 15.1527 19.8308L16 19.0055L16.8473 19.8308C16.953 19.9338 17.0916 19.9853 17.2301 19.9853C17.3686 19.9853 17.5072 19.9338 17.6129 19.8308C17.8243 19.6249 17.8243 19.291 17.6129 19.0851L16.7656 18.2597L17.6129 17.4344C17.8244 17.2285 17.8244 16.8945 17.613 16.6886Z'
      fill='#FF4D00'
    />
  </svg>
)

const SavedAsSubmit = () => (
  <svg
    width='80'
    height='80'
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='40' cy='40' r='40' fill='#F7F9FF' />
    <circle cx='40' cy='40' r='27.5' fill='white' stroke='#F5F5F8' />
    <path
      d='M50.276 29.0544C50.7897 28.5359 51.4878 28.2418 52.2177 28.2364C52.9476 28.231 53.65 28.5148 54.1713 29.0257C54.6926 29.5366 54.9905 30.2331 54.9999 30.963C55.0092 31.6929 54.7292 32.3968 54.2212 32.9209L39.5204 51.2987C39.2678 51.5706 38.9631 51.7889 38.6243 51.9404C38.2856 52.0919 37.9197 52.1736 37.5487 52.1806C37.1777 52.1876 36.809 52.1198 36.4648 51.9811C36.1206 51.8425 35.8078 51.6359 35.5452 51.3737L25.7984 41.6307C25.2805 41.1125 24.9896 40.4098 24.9897 39.6771C24.9899 38.9445 25.2811 38.2419 25.7993 37.7239C26.3175 37.206 27.0203 36.9151 27.7529 36.9153C28.4856 36.9155 29.1882 37.2067 29.7061 37.7249L37.4146 45.4353L50.2028 29.1407C50.2261 29.111 50.2511 29.0828 50.2778 29.0563L50.276 29.0544Z'
      fill='#87C549'
    />
  </svg>
)

const Delete = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.437 8.25H18.062L17.367 19.375C17.3352 19.883 17.1109 20.3597 16.7399 20.708C16.3688 21.0564 15.879 21.2502 15.37 21.25H9.13C8.62105 21.2502 8.13115 21.0564 7.76012 20.708C7.38908 20.3597 7.16481 19.883 7.133 19.375L6.437 8.25ZM19.25 5.25V7.25H5.25V5.25H8.25V4.25C8.25 3.71957 8.46071 3.21086 8.83579 2.83579C9.21086 2.46071 9.71957 2.25 10.25 2.25H14.25C14.7804 2.25 15.2891 2.46071 15.6642 2.83579C16.0393 3.21086 16.25 3.71957 16.25 4.25V5.25H19.25ZM10.25 5.25H14.25V4.25H10.25V5.25Z'
      fill={props.color || '#F45B51'}
    />
  </svg>
)

const BlueDelete = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.437 8.25H18.062L17.367 19.375C17.3352 19.883 17.1109 20.3597 16.7399 20.708C16.3688 21.0564 15.879 21.2502 15.37 21.25H9.13C8.62105 21.2502 8.13115 21.0564 7.76012 20.708C7.38908 20.3597 7.16481 19.883 7.133 19.375L6.437 8.25ZM19.25 5.25V7.25H5.25V5.25H8.25V4.25C8.25 3.71957 8.46071 3.21086 8.83579 2.83579C9.21086 2.46071 9.71957 2.25 10.25 2.25H14.25C14.7804 2.25 15.2891 2.46071 15.6642 2.83579C16.0393 3.21086 16.25 3.71957 16.25 4.25V5.25H19.25ZM10.25 5.25H14.25V4.25H10.25V5.25Z'
      fill={props.color || '#0082AD'}
    />
  </svg>
)

const FolderDocument = (props) => (
  <svg
    width={props.width || '18'}
    height={props.height || '19'}
    viewBox={`0 0 ${props.width || '18'} ${props.height || '19'}`}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.5 3.28271H10.5L9 1.78271H4.5C4.10218 1.78271 3.72064 1.94075 3.43934 2.22205C3.15804 2.50336 3 2.88489 3 3.28271V12.2827C3 12.6805 3.15804 13.0621 3.43934 13.3434C3.72064 13.6247 4.10218 13.7827 4.5 13.7827H16.5C16.8978 13.7827 17.2794 13.6247 17.5607 13.3434C17.842 13.0621 18 12.6805 18 12.2827V4.78271C18 4.38489 17.842 4.00336 17.5607 3.72205C17.2794 3.44075 16.8978 3.28271 16.5 3.28271ZM1.5 4.78271H0V15.2827C0 15.6805 0.158035 16.0621 0.43934 16.3434C0.720644 16.6247 1.10218 16.7827 1.5 16.7827H15V15.2827H1.5V4.78271Z'
      fill={props.color || '#95C123'}
    />
  </svg>
)

const FilterIcon = () => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.70879 7.99919V13.2518C9.73629 13.4518 9.66755 13.6651 9.50945 13.8051C9.44585 13.8669 9.37031 13.9159 9.28716 13.9493C9.204 13.9828 9.11485 14 9.02483 14C8.9348 14 8.84565 13.9828 8.7625 13.9493C8.67934 13.9159 8.6038 13.8669 8.54021 13.8051L7.15852 12.4652C7.08355 12.3942 7.02654 12.3073 6.99196 12.2113C6.95738 12.1153 6.94616 12.0129 6.95917 11.912V7.99919H6.93855L2.9791 3.07985C2.86747 2.94089 2.8171 2.76473 2.839 2.58987C2.8609 2.41501 2.95328 2.25566 3.09596 2.14665C3.22657 2.05333 3.37092 2 3.52215 2H13.1458C13.297 2 13.4414 2.05333 13.572 2.14665C13.7147 2.25566 13.8071 2.41501 13.829 2.58987C13.8509 2.76473 13.8005 2.94089 13.6889 3.07985L9.72941 7.99919H9.70879Z'
      fill='white'
    />
  </svg>
)

const FormFilledIcon = (props) => (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.26172 9.5C7.26172 9.63261 7.20904 9.75979 7.11527 9.85355C7.0215 9.94732 6.89433 10 6.76172 10C6.62911 10 6.50193 9.94732 6.40817 9.85355C6.3144 9.75979 6.26172 9.63261 6.26172 9.5C6.26172 9.36739 6.3144 9.24021 6.40817 9.14645C6.50193 9.05268 6.62911 9 6.76172 9C6.89433 9 7.0215 9.05268 7.11527 9.14645C7.20904 9.24021 7.26172 9.36739 7.26172 9.5ZM6.76172 14C6.89433 14 7.0215 13.9473 7.11527 13.8536C7.20904 13.7598 7.26172 13.6326 7.26172 13.5C7.26172 13.3674 7.20904 13.2402 7.11527 13.1464C7.0215 13.0527 6.89433 13 6.76172 13C6.62911 13 6.50193 13.0527 6.40817 13.1464C6.3144 13.2402 6.26172 13.3674 6.26172 13.5C6.26172 13.6326 6.3144 13.7598 6.40817 13.8536C6.50193 13.9473 6.62911 14 6.76172 14ZM3.26172 6C3.26172 5.20435 3.57779 4.44129 4.1404 3.87868C4.70301 3.31607 5.46607 3 6.26172 3H14.2617C15.0574 3 15.8204 3.31607 16.383 3.87868C16.9456 4.44129 17.2617 5.20435 17.2617 6V9.6C16.4875 9.2053 15.6308 8.99968 14.7617 9H9.76172C9.62911 9 9.50193 9.05268 9.40816 9.14645C9.3144 9.24021 9.26172 9.36739 9.26172 9.5C9.26172 9.63261 9.3144 9.75979 9.40816 9.85355C9.50193 9.94732 9.62911 10 9.76172 10H11.5987C10.8767 10.5075 10.2875 11.1814 9.8807 11.9646C9.47394 12.7478 9.26164 13.6175 9.26172 14.5C9.26172 15.4 9.47772 16.25 9.86172 17H6.26172C5.46607 17 4.70301 16.6839 4.1404 16.1213C3.57779 15.5587 3.26172 14.7956 3.26172 14V6ZM5.76172 5C5.62911 5 5.50193 5.05268 5.40817 5.14645C5.3144 5.24021 5.26172 5.36739 5.26172 5.5C5.26172 5.63261 5.3144 5.75979 5.40817 5.85355C5.50193 5.94732 5.62911 6 5.76172 6H14.7617C14.8943 6 15.0215 5.94732 15.1153 5.85355C15.209 5.75979 15.2617 5.63261 15.2617 5.5C15.2617 5.36739 15.209 5.24021 15.1153 5.14645C15.0215 5.05268 14.8943 5 14.7617 5H5.76172ZM6.76172 11C7.15954 11 7.54107 10.842 7.82238 10.5607C8.10368 10.2794 8.26172 9.89782 8.26172 9.5C8.26172 9.10218 8.10368 8.72064 7.82238 8.43934C7.54107 8.15804 7.15954 8 6.76172 8C6.36389 8 5.98236 8.15804 5.70106 8.43934C5.41975 8.72064 5.26172 9.10218 5.26172 9.5C5.26172 9.89782 5.41975 10.2794 5.70106 10.5607C5.98236 10.842 6.36389 11 6.76172 11ZM8.26172 13.5C8.26172 13.1022 8.10368 12.7206 7.82238 12.4393C7.54107 12.158 7.15954 12 6.76172 12C6.36389 12 5.98236 12.158 5.70106 12.4393C5.41975 12.7206 5.26172 13.1022 5.26172 13.5C5.26172 13.8978 5.41975 14.2794 5.70106 14.5607C5.98236 14.842 6.36389 15 6.76172 15C7.15954 15 7.54107 14.842 7.82238 14.5607C8.10368 14.2794 8.26172 13.8978 8.26172 13.5ZM19.2617 14.5C19.2617 15.6935 18.7876 16.8381 17.9437 17.682C17.0998 18.5259 15.9552 19 14.7617 19C13.5682 19 12.4237 18.5259 11.5797 17.682C10.7358 16.8381 10.2617 15.6935 10.2617 14.5C10.2617 13.3065 10.7358 12.1619 11.5797 11.318C12.4237 10.4741 13.5682 10 14.7617 10C15.9552 10 17.0998 10.4741 17.9437 11.318C18.7876 12.1619 19.2617 13.3065 19.2617 14.5ZM15.2617 12.5C15.2617 12.3674 15.209 12.2402 15.1153 12.1464C15.0215 12.0527 14.8943 12 14.7617 12C14.6291 12 14.5019 12.0527 14.4082 12.1464C14.3144 12.2402 14.2617 12.3674 14.2617 12.5V14H12.7617C12.6291 14 12.5019 14.0527 12.4082 14.1464C12.3144 14.2402 12.2617 14.3674 12.2617 14.5C12.2617 14.6326 12.3144 14.7598 12.4082 14.8536C12.5019 14.9473 12.6291 15 12.7617 15H14.2617V16.5C14.2617 16.6326 14.3144 16.7598 14.4082 16.8536C14.5019 16.9473 14.6291 17 14.7617 17C14.8943 17 15.0215 16.9473 15.1153 16.8536C15.209 16.7598 15.2617 16.6326 15.2617 16.5V15H16.7617C16.8943 15 17.0215 14.9473 17.1153 14.8536C17.209 14.7598 17.2617 14.6326 17.2617 14.5C17.2617 14.3674 17.209 14.2402 17.1153 14.1464C17.0215 14.0527 16.8943 14 16.7617 14H15.2617V12.5Z'
      fill={props.color || '#0A81AD'}
    />
  </svg>
)

const NAReportIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.00781 17.2428L12.2508 11.9998L17.4938 17.2428M17.4938 6.75684L12.2498 11.9998L7.00781 6.75684'
      stroke='#E82D2D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const OKReportIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.54627 15.15L18.0213 6.675C18.2213 6.475 18.4546 6.375 18.7213 6.375C18.9879 6.375 19.2213 6.475 19.4213 6.675C19.6213 6.875 19.7213 7.11267 19.7213 7.388C19.7213 7.66333 19.6213 7.90067 19.4213 8.1L10.2463 17.3C10.0463 17.5 9.81294 17.6 9.54627 17.6C9.27961 17.6 9.04627 17.5 8.84627 17.3L4.54627 13C4.34627 12.8 4.25027 12.5627 4.25827 12.288C4.26627 12.0133 4.37061 11.7757 4.57127 11.575C4.77194 11.3743 5.00961 11.2743 5.28427 11.275C5.55894 11.2757 5.79627 11.3757 5.99627 11.575L9.54627 15.15Z'
      fill='#95C123'
    />
  </svg>
)

const ExcelIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3859_9484)'>
      <path
        d='M4.04586 8.00019L2.28906 6.24446L3.04426 5.48926L4.8 7.24606L6.55573 5.48926L7.31093 6.24446L5.55413 8.00019L7.31093 9.75592L6.55573 10.5111L4.8 8.75432L3.04426 10.5111L2.28906 9.75592L4.04586 8.00019Z'
        fill='#0A81AD'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.73333 0C3.30899 0 2.90202 0.168571 2.60196 0.468629C2.3019 0.768687 2.13333 1.17565 2.13333 1.6V3.2H1.6C1.17565 3.2 0.768687 3.36857 0.468629 3.66863C0.168571 3.96869 0 4.37565 0 4.8L0 11.2C0 11.6243 0.168571 12.0313 0.468629 12.3314C0.768687 12.6314 1.17565 12.8 1.6 12.8H2.13333V14.4C2.13333 14.8243 2.3019 15.2313 2.60196 15.5314C2.90202 15.8314 3.30899 16 3.73333 16H14.4C14.8243 16 15.2313 15.8314 15.5314 15.5314C15.8314 15.2313 16 14.8243 16 14.4V1.6C16 1.17565 15.8314 0.768687 15.5314 0.468629C15.2313 0.168571 14.8243 0 14.4 0L3.73333 0ZM1.6 4.26667C1.45855 4.26667 1.3229 4.32286 1.22288 4.42288C1.12286 4.5229 1.06667 4.65855 1.06667 4.8V11.2C1.06667 11.3414 1.12286 11.4771 1.22288 11.5771C1.3229 11.6771 1.45855 11.7333 1.6 11.7333H8C8.14145 11.7333 8.2771 11.6771 8.37712 11.5771C8.47714 11.4771 8.53333 11.3414 8.53333 11.2V4.8C8.53333 4.65855 8.47714 4.5229 8.37712 4.42288C8.2771 4.32286 8.14145 4.26667 8 4.26667H1.6Z'
        fill='#0A81AD'
      />
    </g>
    <defs>
      <clipPath id='clip0_3859_9484'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const ArrowDown = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.375 7.5L10 13.125L15.625 7.5'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export {
  Delete,
  Logout,
  PdfIcon,
  PortSvg,
  DocxIcon,
  HomeIcon,
  XlsxIcon,
  ArrowDown,
  CloudIcon,
  PointHere,
  ExcelIcon,
  Progress1,
  Progress2,
  Progress3,
  Progress4,
  Progress5,
  Progress6,
  Satellite,
  BlueDelete,
  FilterIcon,
  LintasIcon,
  SearchIcon,
  StreetView,
  VesselIcon,
  NAReportIcon,
  OKReportIcon,
  Progress3Red,
  ProgressDone,
  ProgressGrey,
  EquipmentIcon,
  FloatingCrane,
  Progress2Grey,
  ProgressError,
  SavedAsSubmit,
  FolderDocument,
  FormFilledIcon,
  FullScreenExit,
  FullScreenEnter,
  UnfinalizedWApprovalIcon,
  UnfinalizedWOApprovalIcon
}
